"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint no-fallthrough: 0 */
function createAccessor(method) {
    return function (date) {
        return date['get' + method]();
    };
}
function createSetter(method) {
    return function (date, val) {
        date = date ? new Date(date.valueOf()) : new Date();
        date['set' + method](val);
        return date;
    };
}
exports.getMilliseconds = createAccessor('Milliseconds');
exports.getSeconds = createAccessor('Seconds');
exports.getMinutes = createAccessor('Minutes');
exports.getHours = createAccessor('Hours');
exports.getDay = createAccessor('Day');
exports.getDate = createAccessor('Date');
exports.getMonth = createAccessor('Month');
exports.getYear = createAccessor('FullYear');
function getWeekday(date, firstDay) {
    if (firstDay === void 0) { firstDay = 0; }
    return (exports.getDay(date) + 7 - firstDay) % 7;
}
exports.getWeekday = getWeekday;
exports.setMilliseconds = createSetter('Milliseconds');
exports.setSeconds = createSetter('Seconds');
exports.setMinutes = createSetter('Minutes');
exports.setHours = createSetter('Hours');
exports.setDay = createSetter('Day');
exports.setDate = createSetter('Date');
exports.setMonth = createSetter('Month');
exports.setYear = createSetter('FullYear');
function addMath(date, val) {
    var current = exports.getMonth(date);
    var newMonth = (current + val);
    date = exports.setMonth(date, newMonth);
    if (newMonth < 0) {
        newMonth = 12 + newMonth % 12;
    }
    // month rollover
    if (exports.getMonth(date) !== (newMonth % 12)) {
        // move to last of month
        date = exports.setDate(date, 0);
    }
    return date;
}
function add(date, num, unit) {
    date = date ? new Date(date.valueOf()) : new Date();
    switch (unit) {
        case 'milliseconds':
            return exports.setMilliseconds(date, exports.getMilliseconds(date) + num);
        case 'seconds':
            return exports.setSeconds(date, exports.getSeconds(date) + num);
        case 'minutes':
            return exports.setMinutes(date, exports.getMinutes(date) + num);
        case 'hours':
            return exports.setHours(date, exports.getHours(date) + num);
        case 'year':
            return exports.setYear(date, exports.getYear(date) + num);
        case 'day':
            return exports.setDate(date, exports.getDate(date) + num);
        case 'week':
            return exports.setDate(date, exports.getDate(date) + (7 * num));
        case 'month':
            return addMath(date, num);
        case 'decade':
            return exports.setYear(date, exports.getYear(date) + (num * 10));
        case 'century':
            return exports.setYear(date, exports.getYear(date) + (num * 100));
    }
    throw new TypeError('Invalid units: "' + unit + '"');
}
exports.add = add;
function setWeekday(date, val, firstDay) {
    if (firstDay === void 0) { firstDay = 0; }
    var weekday = (exports.getDay(date) + 7 - firstDay) % 7;
    return add(date, val - weekday, 'day');
}
exports.setWeekday = setWeekday;
function subtract(date, num, unit) {
    return add(date, -num, unit);
}
exports.subtract = subtract;
function startOf(date, unit, firstOfWeek) {
    date = date ? new Date(date.valueOf()) : new Date();
    // explicit fallthrough
    switch (unit) {
        case 'century':
        case 'decade':
        case 'year':
            date = exports.setMonth(date, 0);
        // Fallthrough
        case 'month':
            date = exports.setDate(date, 1);
        // Fallthrough
        case 'week':
        case 'day':
            date = exports.setHours(date, 0);
        // Fallthrough
        case 'hours':
            date = exports.setMinutes(date, 0);
        // Fallthrough
        case 'minutes':
            date = exports.setSeconds(date, 0);
        // Fallthrough
        case 'seconds':
            date = exports.setMilliseconds(date, 0);
    }
    if (unit === 'decade') {
        date = subtract(date, exports.getYear(date) % 10, 'year');
    }
    if (unit === 'century') {
        date = subtract(date, exports.getYear(date) % 100, 'year');
    }
    if (unit === 'week') {
        date = setWeekday(date, 0, firstOfWeek);
    }
    return date;
}
exports.startOf = startOf;
function getDecade(date) {
    return exports.getYear(startOf(date, 'decade'));
}
exports.getDecade = getDecade;
function setDecade(date, val) {
    return add(date, val + 10, 'year');
}
exports.setDecade = setDecade;
function getCentury(date) {
    return exports.getYear(startOf(date, 'century'));
}
exports.getCentury = getCentury;
function setCentury(date, val) {
    return add(date, val + 100, 'year');
}
exports.setCentury = setCentury;
function createComparer(operator) {
    return function (a, b, unit) {
        return operator(+startOf(a, unit), +startOf(b, unit));
    };
}
function endOf(date, unit, firstOfWeek) {
    date = date ? new Date(date.valueOf()) : new Date();
    date = startOf(date, unit, firstOfWeek);
    date = add(date, 1, unit);
    date = subtract(date, 1, 'milliseconds');
    return date;
}
exports.endOf = endOf;
exports.eq = createComparer(function (a, b) { return a === b; });
exports.neq = createComparer(function (a, b) { return a !== b; });
exports.gt = createComparer(function (a, b) { return a > b; });
exports.gte = createComparer(function (a, b) { return a >= b; });
exports.lt = createComparer(function (a, b) { return a < b; });
exports.lte = createComparer(function (a, b) { return a <= b; });
function min() {
    var dates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        dates[_i] = arguments[_i];
    }
    return new Date(Math.min.apply(Math, dates.map(function (date) { return date.valueOf(); })));
}
exports.min = min;
function max() {
    var dates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        dates[_i] = arguments[_i];
    }
    return new Date(Math.max.apply(Math, dates.map(function (date) { return date.valueOf(); })));
}
exports.max = max;
function inRange(day, min, max, unit) {
    if (unit === void 0) { unit = 'day'; }
    return (!min || exports.gte(day, min, unit)) && (!max || exports.lte(day, max, unit));
}
exports.inRange = inRange;
function inArray(day, blackListDates) {
    return blackListDates ? (blackListDates.find(function (x) {
        return x.getUTCFullYear() === (day).getUTCFullYear() && x.getUTCMonth() === (day).getUTCMonth() && x.getUTCDate() === (day).getUTCDate();
    })) !== undefined : false;
}
exports.inArray = inArray;
function absoluteFloor(number) {
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function diff(date1, date2, unit, asFloat) {
    if (asFloat === void 0) { asFloat = true; }
    var dividend;
    var divisor;
    switch (unit) {
        case 'milliseconds':
        case 'seconds':
        case 'minutes':
        case 'hours':
        case 'day':
        case 'week':
            dividend = date2.getTime() - date1.getTime();
            break;
        case 'month':
        case 'year':
        case 'decade':
        case 'century':
            dividend = (exports.getYear(date2) - exports.getYear(date1)) * 12 + exports.getMonth(date2) - exports.getMonth(date1);
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    switch (unit) {
        case 'milliseconds':
            divisor = 1;
            break;
        case 'seconds':
            divisor = 1000;
            break;
        case 'minutes':
            divisor = 1000 * 60;
            break;
        case 'hours':
            divisor = 1000 * 60 * 60;
            break;
        case 'day':
            divisor = 1000 * 60 * 60 * 24;
            break;
        case 'week':
            divisor = 1000 * 60 * 60 * 24 * 7;
            break;
        case 'month':
            divisor = 1;
            break;
        case 'year':
            divisor = 12;
            break;
        case 'decade':
            divisor = 120;
            break;
        case 'century':
            divisor = 1200;
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    var result = dividend / divisor;
    return asFloat ? result : absoluteFloor(result);
}
exports.diff = diff;
